import {
  Button,
  IconText,
  Image,
  Input,
} from "@wac-ui-dashboard/wac_component_library";
import Select from "react-select";
import useAddSeasonalTheme from "./useAddSeasonalTheme";
import ColorPickerField from "../../../../utils/components/ColorPickerField";
import Style from "../seasonalTheme.module.scss";
const AddSeasonalTheme = ({ isStickyFooter, handleCreateClick, refetch }) => {
  const {
    formik,
    isEdit,
    basicData,
    isLoading,
    imageName,
    imagePreview,
    isLoadingImage,
    arabicImageName,
    arabicImagePreview,
    isArabicImageLoading,
    recapImageName,
    recapImagePreview,
    isLoadingRecapImage,
    arabicRecapImageName,
    arabicRecapImagePreview,
    isLoadingArabicRecapImage,
    handleAddSelectedUser,
    handleRemoveSelectedUser,
    handleImageChange,
    handleTypeChange,
    handleSelectedTypeChange,
    getFieldError,
    closeModal,
    getMinEndDate,
    getMaxDate,
    typeSlug,
  } = useAddSeasonalTheme(handleCreateClick, refetch);

  return (
    <div className="row">
      <div className="input-wrap pro-mb-4">
        <ColorPickerField label="Theme Color" name="theme_color" formik={formik} />
        <ColorPickerField label="Text Color" name="text_color" formik={formik} />
        {/* <ColorPickerField label="Menu Color" name="menu_color" formik={formik} /> */}
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
           Theme Type
          </label>
          <Select
            id="theme_type"
            name="theme_type"
            placeholder={"Select"}
            className={`pro-input lg  ${
              getFieldError("theme_type") && " error"
            }`}
            classNamePrefix="pro-input"
            options={basicData?.data?.content_types ?? []}
            value={formik?.values?.theme_type ?? {}}
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            onBlur={formik.handleBlur("theme_type")}
            onChange={(e) => handleTypeChange(e)}
            menuPlacement="auto"
            isDisabled={true}
          />
          {getFieldError("theme_type") && (
            <span className="error-text">{getFieldError("theme_type")}</span>
          )}
        </div>
{formik.values.theme_type?.id === 2 &&(
  <>
         <Input
          label={"From Date"}
          type="date"
          id="start_date"
          name="start_date"
          className={`pro-input lg ${getFieldError("start_date") && " error"}`}
          {...formik.getFieldProps("start_date")}
          min={new Date().toISOString().split("T")[0]}
          max={getMaxDate()}
          error={getFieldError("start_date")}
          errorMessage={getFieldError("start_date")}
        />

          <Input
            label={"To Date"}
            type="date"
            id="end_date"
            name="end_date"
            className={`pro-input lg ${getFieldError("end_date") && " error"}`}
            {...formik.getFieldProps("end_date")}
            min={getMinEndDate()}
            disabled={formik?.values?.start_date === ""}
            error={getFieldError("end_date")}
            errorMessage={getFieldError("end_date")}
          />
        </>
)}
         <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Selected Type
          </label>
          <Select
            id="selected_type"
            name="selected_type"
            placeholder={"Select"}
            className={`pro-input lg  ${getFieldError("selected_type") && " error"}`}
            classNamePrefix="pro-input"
            options={basicData?.data?.navigation_types ?? []}
            value={formik?.values?.selected_type ?? {}}
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            onBlur={formik.handleBlur("selected_type")}
            onChange={(e) => handleSelectedTypeChange(e)}
            menuPlacement="auto"
          />
          {getFieldError("selected_type") && (
            <span className="error-text">{getFieldError("selected_type")}</span>
          )}
        </div>

        {basicData?.data?.dropdown_list?.hasOwnProperty(typeSlug) ? (
          <div className="input-wrap pro-mb-4">
            <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
              Navigate To
            </label>
            <Select
              id="selected_item"
              name="selected_item"
              placeholder={"Select"}
              className={`pro-input lg  ${
                getFieldError("selected_item") && " error"
              }`}
              classNamePrefix="pro-input"
              options={basicData?.data?.dropdown_list[typeSlug] ?? []}
              getOptionLabel={(option) => option?.name}
              getOptionValue={(option) => option?._id}
              value={formik.values.selected_item ?? {}}
              onBlur={formik.handleBlur("selected_item")}
              onChange={(value) =>
                formik?.setFieldValue("selected_item", value || null)
              }
              menuPlacement="auto"
            />
            {getFieldError("selected_item") && (
              <span className="error-text">
                {getFieldError("selected_item")}
              </span>
            )}
          </div>
        ) : (
          ""
        )}

        <div className="input-wrap pro-mb-4 ">
          <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
            Image
          </label>
          <div className="input-drag">
            <input
              type="file"
              accept=".jpeg,.jpg , .png "
              className={`pro-input ${
                formik.errors.image && formik.touched.image && " error"
              }`}
              id="image"
              onBlur={formik.handleBlur("image")}
              onChange={(e) => handleImageChange(e, "image")}
            />
            <span className="input-drag-box">
              <IconText
                title={
                  isLoadingImage
                    ? "Uploading..."
                    : imageName !== ""
                    ? imageName
                    : `Drop files to attach or browse`
                }
              />
            </span>
            {formik.touched.image && formik.errors.image && (
              <span className="error-text">{formik.errors.image}</span>
            )}
          </div>
          <div className={`col-2 pro-my-2`}>
            <div className={``}>
              <Image
                width={100}
                height={100}
                src={imagePreview}
                alt={`image - 01`}
              />
            </div>
          </div>
        </div>
        <div className="input-wrap pro-mb-4 pro-rtl">
          <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
            ( صورة ) Image
          </label>
          <div className="input-drag">
            <input
              type="file"
              accept=".jpeg,.jpg , .png "
              className={`pro-input ${
                formik.errors.alias_image &&
                formik.touched.alias_image &&
                " error"
              }`}
              id="image"
              onBlur={formik.handleBlur("alias_image")}
              onChange={(e) => handleImageChange(e, "alias_image")}
            />
            <span className="input-drag-box">
              <IconText
                title={
                  isArabicImageLoading
                    ? "...Uploading"
                    : arabicImageName !== ""
                    ? arabicImageName
                    : `Drop files to attach or browse`
                }
              />
            </span>
            {formik.touched.alias_image &&
              formik.errors.alias_image && (
                <span className="error-text">
                  {formik.errors.alias_image}
                </span>
              )}
          </div>
          <div className={`col-2 pro-my-2`}>
            <div className={``}>
              <Image
                width={100}
                height={100}
                src={arabicImagePreview}
                alt={`image - 01`}
              />
            </div>
          </div>
        </div>
        {formik.values?.selected_type?.id?.toString() === "5" && (
          <>
            <div className="input-wrap pro-mb-4 ">
              <label
                htmlFor=""
                className={`pro-font-sm pro-mb-1 pro-fw-medium`}
              >
                Recap Image
              </label>
              <div className="input-drag">
                <input
                  type="file"
                  accept=".jpeg,.jpg , .png "
                  className={`pro-input ${
                    formik.errors.recap_image &&
                    formik.touched.recap_image &&
                    " error"
                  }`}
                  id="image"
                  onBlur={formik.handleBlur("recap_image")}
                  onChange={(e) => handleImageChange(e, "recap_image")}
                />
                <span className="input-drag-box">
                  <IconText
                    title={
                      isLoadingRecapImage
                        ? "Uploading..."
                        : recapImageName !== ""
                        ? recapImageName
                        : `Drop files to attach or browse`
                    }
                  />
                </span>
                {formik.touched.recap_image && formik.errors.recap_image && (
                  <span className="error-text">
                    {formik.errors.recap_image}
                  </span>
                )}
              </div>
              <div className={`col-2 pro-my-2`}>
                <div className={``}>
                  <Image
                    width={100}
                    height={100}
                    src={recapImagePreview}
                    alt={`image - 01`}
                  />
                </div>
              </div>
            </div>
            <div className="input-wrap pro-mb-4 pro-rtl">
              <label
                htmlFor=""
                className={`pro-font-sm pro-mb-1 pro-fw-medium`}
              >
                ( صورة الملخص ) Recap image
              </label>
              <div className="input-drag">
                <input
                  type="file"
                  accept=".jpeg,.jpg , .png "
                  className={`pro-input ${
                    formik.errors.alias_recap_image &&
                    formik.touched.alias_recap_image &&
                    " error"
                  }`}
                  id="image"
                  onBlur={formik.handleBlur("alias_recap_image")}
                  onChange={(e) => handleImageChange(e, "alias_recap_image")}
                />
                <span className="input-drag-box">
                  <IconText
                    title={
                      isLoadingArabicRecapImage
                        ? "...Uploading"
                        : arabicRecapImageName !== ""
                        ? arabicRecapImageName
                        : `Drop files to attach or browse`
                    }
                  />
                </span>
                {formik.touched.alias_recap_image &&
                  formik.errors.alias_recap_image && (
                    <span className="error-text">
                      {formik.errors.alias_recap_image}
                    </span>
                  )}
              </div>
              <div className={`col-2 pro-my-2`}>
                <div className={``}>
                  <Image
                    width={100}
                    height={100}
                    src={arabicRecapImagePreview}
                    alt={`image - 01`}
                  />
                </div>
              </div>
            </div>
          </>
        )}
        <>
          <div className={Style.add_wrap}>
            <Input
              label={"Add Users"}
              type="text"
              id="add_user"
              name="add_user"
              className={`pro-input lg ${getFieldError("add_user") && "error"}`}
              {...formik.getFieldProps("add_user")}
              onChange={(e) => formik.setFieldValue("add_user", e.target.value??"")}
              error={getFieldError("add_user")}
              errorMessage={getFieldError("add_user")}
            />
            <button
              onClick={handleAddSelectedUser}
              className={`${Style.add_btn}`}
            >
              <span className="material-symbols-outlined x4"> add </span>
            </button>
          </div>
          <div className={`${Style.number_badge_wrap} input-wrap pro-mb-4`}>
            {formik?.values?.user_mobiles?.map((item, index) => (
              <div key={index} className={Style.badge}>
                {item}
                <span
                  onClick={() => handleRemoveSelectedUser(index)}
                  className="material-symbols-outlined"
                >
                  close
                </span>
              </div>
            ))}
          </div>
          {formik?.errors?.user_mobiles &&
            formik?.values?.user_mobiles?.length <= 0 && (
              <span className="error-text error error-img">
                {getFieldError("user_mobiles")}
              </span>
            )}
        </>
        <div className=" pro-check-box pro-flex-column pro-py-2 col-2">
          <div className="form-check form-switch ">
            <input
              className="form-check-input cursor-pointer"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              checked={Boolean(formik.values?.status === 1) ?? false}
              onChange={(e) =>
                formik.setFieldValue(`status`, e?.target?.checked ? 1 : 2)
              }
            />
            <label htmlFor="default" className="pro-check-label">
              Status
            </label>
          </div>
          {getFieldError("status") && (
             <span className="error-text-c1">
                {getFieldError("status")}
              </span>
          )}
        </div>
        <div
          className={`col-12 pro-d-flex pro-justify-end ${
            isStickyFooter && "offcanvas-footer-sticky-btns"
          }`}
        >
          <Button
            className={"pro-btn-link lg pro-px-5"}
            onClick={() => closeModal()}
          >
            Cancel
          </Button>

          <Button
            className={`pro-btn-primary lg pro-ms-3 ${false ? "loading" : ""}`}
            type="submit"
            disabled={isLoading || isLoadingImage || isArabicImageLoading}
            onClick={formik.handleSubmit}
          >
            {!isEdit
              ? isLoading
                ? "Creating..."
                : "Create"
              : isLoading
              ? "Updating..."
              : "Update"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddSeasonalTheme;
